import { RegisteredComponent } from "@builder.io/sdk-react";

export const formConfig: Omit<RegisteredComponent, "component"> = {
  name: "Form:Form",
  override: true,
  canHaveChildren: true,
  noWrap: true,
  image:
    "https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2Fef36d2a846134910b64b88e6d18c5ca5",
  shouldReceiveBuilderProps: {
    builderContext: true,
    builderBlock: true,
    builderComponents: true,
    builderLinkComponent: true,
  },
  inputs: [
    {
      name: "onSubmit",
      type: "javascript",
      localized: false,
    },
  ],
  defaultStyles: {
    boxShadow: "0 20px 40px 0 var(--color-swdc-black-a20)",
    padding: "var(--spacing-8)",
  },
};
